import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SpinIcon from "../Icons/spinIcon";
import clsx from "clsx";
export class SubmitButtonProps {
    constructor() {
        this.buttonStyle = 'filled';
        this.size = 'medium';
        this.text_align = 'center';
        this.button_align = 'left';
    }
}
const SubmitButton = ({ isDisabled, isSubmitting, icon, children, type, onClick, buttonStyle = 'filled', size = 'medium', text_align = 'center', button_align = 'left', className, style }) => {
    return (_jsxs("button", { disabled: isDisabled || isSubmitting, type: type, onClick: onClick, style: style, className: clsx('navigation-focus-ring-text-bold-lg enabled:active:animate-press-down text-primary focus:outline-none focus:ring-0 items-center space-x-1 disabled:bg-secondary-300 disabled:text-secondary-text/50 disabled:cursor-not-allowed relative w-full flex justify-center font-medium rounded-xl transform hover:brightness-125 transition duration-200 ease-in-out', className, {
            'text-primary-buttonTextColor bg-primary-500': buttonStyle === 'filled',
            'text-primary-text bg-secondary-300 hover:bg-secondary-400': buttonStyle === 'secondary',
            'py-4 px-4 min-h-14': size === 'large',
            'py-3 px-2 md:px-3 min-h-12': size === 'medium',
            'py-2.5 px-2.5 text-sm min-h-10': size === 'small',
        }), children: [_jsxs("span", { className: `${button_align === "right" ? 'order-last' : 'order-first'} ${text_align === 'center' ? "absolute left-0 inset-y-0 flex items-center pl-3" : "relative"}`, children: [(!isDisabled && !isSubmitting) && icon, isSubmitting ?
                        _jsx(SpinIcon, { className: "animate-spin h-5 w-5" })
                        : null] }), _jsx("span", { className: `grow ${text_align === 'left' ? 'text-left' : 'text-center'}`, children: children })] }));
};
const text_styles = {
    'mltln-text-light': {
        primary: 'text-primary',
        secondary: 'text-primary-100'
    },
    'mltln-text-dark': {
        primary: 'text-primary',
        secondary: 'text-primary-600'
    }
};
export const DoubleLineText = ({ primaryText, secondarytext, colorStyle, reversed }) => {
    return _jsxs("div", { className: `leading-3 flex ${reversed ? 'flex-col-reverse' : 'flex-col'}`, children: [_jsx("div", { className: `text-xs ${text_styles[colorStyle].secondary}`, children: secondarytext }), _jsx("div", { className: `${text_styles[colorStyle].primary}`, children: primaryText })] });
};
export default SubmitButton;
